import type { Practitioner } from 'fhir/r4';
import { v4 as uuid } from 'uuid';

import * as FHIRUtils from '../fhirutils';

export function build(
  practitionerOrgId: string,
  practitionerType: string, //eg: RD or OA
  practitionerName: { first: string; last: string },
  practitionerEmail: string,
  practitionerPhone: string,
  gender: string,
  updatedBy: string
): Practitioner {
  const practitionerId = uuid();

  const practitioner: Practitioner = {
    resourceType: 'Practitioner',
    id: practitionerId,
    identifier: [
      {
        system: 'https://projectwell.io/fhir/organization',
        value: practitionerOrgId,
      },
      {
        system: 'https://projectwell.io/fhir/practitioner-types',
        value: practitionerType,
      },
      {
        system: 'https://projectwell.io/fhir/practitioner-id',
        value: practitionerEmail,
      },
    ],
    active: true,
    name: [
      {
        family: practitionerName.last,
        given: (practitionerName.first?.split(',')?.length === 1
          ? [practitionerName.first]
          : [practitionerName.first?.split(',')[0], practitionerName.first?.split(',')[1]]) as string[],
        use: 'official',
      },
    ],
    gender: gender.toUpperCase() === 'MALE' ? 'male' : gender.toUpperCase() === 'FEMALE' ? 'female' : 'unknown',
    telecom: [
      {
        use: 'home',
      },
      {
        system: 'phone',
        value: practitionerPhone,
        use: 'work',
      },
      {
        system: 'email',
        value: practitionerEmail,
        use: 'work',
      },
    ],
  };

  return FHIRUtils.addUpdatedBy(practitioner, updatedBy);
}
